import { render, staticRenderFns } from "./ViewComboNew.vue?vue&type=template&id=2e7019fd&scoped=true&"
import script from "./ViewComboNew.vue?vue&type=script&lang=js&"
export * from "./ViewComboNew.vue?vue&type=script&lang=js&"
import style0 from "./ViewComboNew.vue?vue&type=style&index=0&id=2e7019fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7019fd",
  null
  
)

export default component.exports